import { Injectable } from '@angular/core';
import { CapGainDistributionDTO } from '@products/types/dto/capgain-distribution.dto.type';
import { Logger } from '@utils/logger';
import { GraphQLFundDataService } from './graphql-fund-data.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CapGainDistribution } from '@products/models/capgain-distribution';
import { CapGainDistributionsMapper } from '@products/utils/mappers/capgain-distributions.type.mapper';
import { MapperFactory } from '@products/utils/mappers/mapper-factory';
import { MapperParams } from '@products/utils/mappers/type.mapper';
import { SiteConfigService } from '@services/site-config.service';
import { Apollo } from 'apollo-angular';
import { DocumentNode } from 'graphql';

const logger = Logger.getLogger('CapGainDistributionService');

@Injectable({
  providedIn: 'root',
})
export class CapgainDistributionService extends GraphQLFundDataService {
  constructor(
    apollo: Apollo,
    siteConfigService: SiteConfigService,
    private mapperFactory: MapperFactory
  ) {
    super(apollo, siteConfigService);
  }

  public register(query: DocumentNode): Observable<CapGainDistribution[]> {
    return super.register(query, this.getVariables()).pipe(
      map((rawCapGainDistributionData) => {
        const capGainDistributionsDTO: CapGainDistributionDTO[] = rawCapGainDistributionData
          ?.data?.CapGainDistribution
          ? rawCapGainDistributionData?.data?.CapGainDistribution
          : null;

        const mappperParams: MapperParams = {
          config: this.siteConfigService,
        };

        const mappedCapGainDistribution: CapGainDistribution[] = this.mapperFactory
          .createMapper(CapGainDistributionsMapper, mappperParams)
          .toDomain(capGainDistributionsDTO);

        return mappedCapGainDistribution;
      })
    );
  }

  /**
   * Return required variables value to graphql query.
   */
  private getVariables(): Record<string, any> {
    return {
      countrycode: this.getCountry(),
      languagecode: this.getLanguage(),
    };
  }
}
